/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1FirmOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_INVENTORY_V1_FIRM_ORDER_STATE_ENTITY_NAME = 'ixc.inventory.v1.FirmOrder';
export const ixcInventoryV1FirmOrderStateEntity = new schema.Entity<IxcInventoryV1FirmOrderState>(IXC_INVENTORY_V1_FIRM_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'firmOrderId' });

